import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Toaster } from "../interface.component";

@Injectable()
export class ToasterService {
    public toastersSubject = new BehaviorSubject<Toaster[]>([]);
    private nextId = 0;
    private maxToasters = 1;

    showToaster(heading: string, description: string, type: string) {
        const currentToasters = this.toastersSubject.value;

        if (currentToasters.length >= this.maxToasters) {
            currentToasters.shift();
        }

        const newToaster: Toaster = {
            id: this.nextId++,
            heading: heading,
            description: description,
            type: type
        };

        this.toastersSubject.next([...this.toastersSubject.value, newToaster]);
        if (type === 'success') {
            setTimeout(() => this.hideToaster(newToaster.id), 5000); // success toast closes itself after 5 sec
        }
    }

    hideToaster(id: number) {
        this.toastersSubject.next(this.toastersSubject.value.filter(toaster => toaster.id !== id));
    }

    // Called when an API request starts. Success toasts are kept (they close themselves after 5 sec), so a data
    // reload right after an action (e.g. Add Note closing its modal) doesn't wipe the confirmation instantly.
    hideAllToasters() {
        this.toastersSubject.next(this.toastersSubject.value.filter(toaster => toaster.type === 'success'));
    }
}
